import React from 'react';
import { Navbar, Nav, Container, Button, Card, Row, Col } from 'react-bootstrap';

export default function ActivitySummary(){
    return (
        <div>
            <Navbar bg="light" expand="lg">
                <Container>
                    <Navbar.Brand href="#">
                        <div className="logo-wrapper">
                            <span className="logo-text">Newsletter</span>
                        </div>
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </div>
    )
} 